// Clerk user IDs that get Captain access without a paid subscription.
const ADMIN_USER_IDS = new Set<string>([
  "user_3HZL57s18I7A8bFilI1rHR1EcMy",
]);

export function isAdminUser(userId: string | null | undefined): boolean {
  return !!userId && ADMIN_USER_IDS.has(userId);
}
